import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

export const SwitchButtonStyled = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 24,
  padding: 0,
  marginRight: 10,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.white.main,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.success.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.success.main,
      border: `6px solid ${theme.palette.white.main}`,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.gray.main,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      backgroundColor: theme.palette.gray.dark,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    margin: '0.13rem',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 12,
    backgroundColor: theme.palette.gray.main,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
